import { isLiteralElement as T, isPoundElement as N, isArgumentElement as S, isDateElement as A, isDateTimeSkeleton as w, isTimeElement as O, isNumberElement as k, isNumberSkeleton as D, isTagElement as R, isSelectElement as V, isPluralElement as L } from "./index101.mjs";
import { MissingValueError as M, InvalidValueTypeError as _, InvalidValueError as I, FormatError as q, ErrorCode as x } from "./index98.mjs";
var l;
(function(a) {
  a[a.literal = 0] = "literal", a[a.object = 1] = "object";
})(l || (l = {}));
function z(a) {
  return a.length < 2 ? a : a.reduce(function(r, s) {
    var i = r[r.length - 1];
    return !i || i.type !== l.literal || s.type !== l.literal ? r.push(s) : i.value += s.value, r;
  }, []);
}
function C(a) {
  return typeof a == "function";
}
function g(a, r, s, i, u, v, y) {
  if (a.length === 1 && T(a[0]))
    return [
      {
        type: l.literal,
        value: a[0].value
      }
    ];
  for (var n = [], c = 0, E = a; c < E.length; c++) {
    var e = E[c];
    if (T(e)) {
      n.push({
        type: l.literal,
        value: e.value
      });
      continue;
    }
    if (N(e)) {
      typeof v == "number" && n.push({
        type: l.literal,
        value: s.getNumberFormat(r).format(v)
      });
      continue;
    }
    var h = e.value;
    if (!(u && h in u))
      throw new M(h, y);
    var t = u[h];
    if (S(e)) {
      (!t || typeof t == "string" || typeof t == "number") && (t = typeof t == "string" || typeof t == "number" ? String(t) : ""), n.push({
        type: typeof t == "string" ? l.literal : l.object,
        value: t
      });
      continue;
    }
    if (A(e)) {
      var o = typeof e.style == "string" ? i.date[e.style] : w(e.style) ? e.style.parsedOptions : void 0;
      n.push({
        type: l.literal,
        value: s.getDateTimeFormat(r, o).format(t)
      });
      continue;
    }
    if (O(e)) {
      var o = typeof e.style == "string" ? i.time[e.style] : w(e.style) ? e.style.parsedOptions : i.time.medium;
      n.push({
        type: l.literal,
        value: s.getDateTimeFormat(r, o).format(t)
      });
      continue;
    }
    if (k(e)) {
      var o = typeof e.style == "string" ? i.number[e.style] : D(e.style) ? e.style.parsedOptions : void 0;
      o && o.scale && (t = t * (o.scale || 1)), n.push({
        type: l.literal,
        value: s.getNumberFormat(r, o).format(t)
      });
      continue;
    }
    if (R(e)) {
      var P = e.children, d = e.value, b = u[d];
      if (!C(b))
        throw new _(d, "function", y);
      var j = g(P, r, s, i, u, v), f = b(j.map(function(m) {
        return m.value;
      }));
      Array.isArray(f) || (f = [f]), n.push.apply(n, f.map(function(m) {
        return {
          type: typeof m == "string" ? l.literal : l.object,
          value: m
        };
      }));
    }
    if (V(e)) {
      var p = e.options[t] || e.options.other;
      if (!p)
        throw new I(e.value, t, Object.keys(e.options), y);
      n.push.apply(n, g(p.value, r, s, i, u));
      continue;
    }
    if (L(e)) {
      var p = e.options["=".concat(t)];
      if (!p) {
        if (!Intl.PluralRules)
          throw new q(`Intl.PluralRules is not available in this environment.
Try polyfilling it using "@formatjs/intl-pluralrules"
`, x.MISSING_INTL_API, y);
        var F = s.getPluralRules(r, { type: e.pluralType }).select(t - (e.offset || 0));
        p = e.options[F] || e.options.other;
      }
      if (!p)
        throw new I(e.value, t, Object.keys(e.options), y);
      n.push.apply(n, g(p.value, r, s, i, u, t - (e.offset || 0)));
      continue;
    }
  }
  return z(n);
}
export {
  l as PART_TYPE,
  g as formatToParts,
  C as isFormatXMLElementFn
};
